import { memo } from "react";
import Info from "~icons/material-symbols/info-outline";
import { css } from "../../../../styled-system/css";

import { t } from "../../../libs/i18n";
const INFO_TEXT = t(
  "　北海道では、物価・エネルギー高などの影響を受けている道民の皆様の負担軽減の一助となるよう、食料品をはじめとした生活必需品等の購入に利用できる『どうみんポイント』を給付します。\n　『どうみんポイント』は、取扱店舗に設置されているＱＲコードをアプリで読み取ることで、お支払いに利用できます。",
); // ref: https://pocketsign.slack.com/archives/C0AEVM174SE/p1779417826918859?thread_ts=1779166530.459989&cid=C0AEVM174SE

export const HokkaidoCampaignInfoCard = memo(() => {
  return (
    <section
      className={css({
        bg: "surface.accentPrimaryLight",
        rounded: "xl",
        p: "16px",
        display: "flex",
        flexDir: "column",
        gap: "12px",
      })}
    >
      <div
        className={css({
          display: "flex",
          gap: "4px",
          alignItems: "flex-start",
        })}
      >
        <Info
          className={css({
            color: "text.accentPrimary",
            width: "24px",
            height: "24px",
            flexShrink: 0,
          })}
        />
        <p
          className={css({
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "1.5",
            color: "text.primary",
          })}
        >
          {t("道民生活応援ポイント給付事業")}
        </p>
      </div>

      <p
        className={css({
          color: "text.secondary",
          fontSize: "14px",
          lineHeight: "1.6",
          pl: "28px",
          whiteSpace: "pre-wrap",
        })}
      >
        {INFO_TEXT}
      </p>
    </section>
  );
});
